import script from "./OrderConfirmationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderConfirmationPage.vue?vue&type=script&setup=true&lang=js"

import "./OrderConfirmationPage.vue?vue&type=style&index=0&id=f0f141e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0f141e0"]])

export default __exports__